import _ from 'lodash'
import { parsePhoneNumberFromString, isValidPhoneNumber } from 'libphonenumber-js'

export const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const toCamelCase = (text) => {
    if(text){
        let capText = _.map(text.toLowerCase().split(' '), function (word) {
            return capitalizeFirstLetter(word)
        }).join('')
        return capText.charAt(0).toLowerCase() + capText.slice(1);
    }
    return text
}
export const parseWordsFromCamelCase = (camelCased) => {
    if(camelCased){
        let str = camelCased.replace(/([a-z](?=[A-Z]))/g, '$1 ')
        return str[0].toUpperCase() + str.slice(1)
    }
    else return camelCased;
}
export const getLinkWithQueryParams = (link, queryParams) => {
    if (queryParams) {
        let paramsString = [];
        _.map(queryParams, (val, key) => {
            if (key && val) paramsString.push(key + '=' + val)
        })
        return link + (paramsString ? ('?' + paramsString.join('&')) : '')
    }
    return link
}

export const exportBlobToFile = ({blobFile, fileName}) => {
    const element = document.createElement("a");
    element.href = URL.createObjectURL(blobFile);
    element.download = fileName;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
}

export const isEmailValid = (email) => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}


export const isPasswordPatternValid = (password) => {
    if (!password || password.length < 8 ||
        password.toLowerCase() === password ||
        password.toUpperCase() === password ||
        !(/\d/.test(password))){
        return false
    }
    return true
}

export const removeEmptyStrings = (obj) => {
    _.map(_.keys(obj), function (key) {
        if(!obj[key] || obj[key] === ''){
            delete obj[key]
        }
    })
    return obj
}

export const compact = (array) => {
    return _.compact(_.filter(array, function (item) {
        return !_.isEmpty(item) && _.compact(_.toArray(item)).length > 0;
    }))
}


export const deepDiff = (object, base) => {
    const changes = (object, base) => {
        return _.transform(object, function (result, value, key) {
            if (!_.isEqual(value, base[key])) {
                result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
            }
        });
    }

    let changesRes = changes(object, base);
    return changesRes;

}

/**
 * Validates a phone number using libphonenumber-js
 * Simple validation function - returns true if valid, false otherwise
 *
 * @param {string} phoneNumber - The phone number to validate
 * @param {string} defaultCountry - The default country code (e.g., 'IL', 'US')
 * @returns {boolean} True if the phone number is valid, false otherwise
 */
export const validatePhoneNumber = (phoneNumber, defaultCountry) => {
    if (!phoneNumber) return false;
    try {
        return isValidPhoneNumber(phoneNumber, defaultCountry);
    } catch {
        return false;
    }
}

/**
 * Formats a phone number for display using national format
 * Example: '+972501234567' with countryCode 'IL' => '050-123-4567'
 *
 * @param {object} params - The function parameters
 * @param {string} params.phone - Phone number (E.164 or local format)
 * @param {string} params.countryCode - Country code (e.g., 'IL', 'US')
 * @returns {string} Formatted phone in national format, or original if parsing fails
 */
export const formatPhoneForDisplay = ({phone, countryCode}) => {
    if (!phone) return '';
    try {
        const phoneNumber = parsePhoneNumberFromString(phone, countryCode);
        if (phoneNumber && phoneNumber.isValid()) {
            return phoneNumber.formatNational();
        }
    } catch {
        // Fall through to return original
    }
    return phone;
}

/**
 * Converts a local phone number to E.164 format using the country code.
 * Example: ('0504499222', 'IL') => '+972504499222'
 *
 * @param {string} phone - The phone number (local or E.164 format)
 * @param {string} countryCode - The country code (e.g., 'IL', 'US')
 * @returns {string} Phone in E.164 format, or original phone if conversion fails
 */
export const formatPhoneToE164 = (phone, countryCode) => {
    if (!phone) return '';

    try {
        const parsed = parsePhoneNumberFromString(phone, countryCode);
        return parsed?.format('E.164') || phone;
    } catch {
        return phone;
    }
}

export const validateIdNumber = (idNumber) => {
    if(idNumber){
        let id = idNumber.replace(/[^0-9]/g, '');
        if(id.length <= 9){
            return id
        } else {
            return idNumber.substring(0, 9)
        }
    }
    return null
}

